import React from 'react';
import protestantism from '../../images/about_us/History_of_Protestantism_vol_3-s.jpg';
import cdSet from '../../images/about_us/Journey__set_of_23_CDs-s.jpg';
import genevan from '../../images/about_us/Genevan-Psalms-in-Harmony-4.jpg';
import cdSing from '../../images/about_us/CD-SING-TO-THE-LORD-4.jpg';
import { Helmet } from 'react-helmet';

import './about-us.scss';

/**
 * About Us Component
 * It contains the section which give informations about us.
 * It shows the history of the company and our beliefs
 */
function AboutUs() {
   return (
      <main className="container-fluid">
         <Helmet>
            <title>Inheritance Publications :: About Us</title>
            <meta name="keywords" content="books, historical books, reformed books, reformed books for children, fiction books, reformed church, historical fiction, historical fiction books, short stories, liturgy, reformed worship, 80 years war, 30 years war, world war 2, Bible books, Christian books, Christian literature, literature, Psalm CDs, Hymn CDs, DVDs, Music DVDs, audio books, sheet music, church sheet music, Dutch sheet music, Psalm sheet music, organ sheet music"/>
            <meta name="description" content="Inheritance Publications is a small company which was established to provide Biblical Reformed literature. We want to maintain the antithesis between right and wrong, between true and false christianity. It is also our desire to give God the honour and glory due to His Name because of His faithfulness. Remembering the great deeds of God in the history of His Church will always cause God's children to stand in awe of His Majesty. It is our aim to reach children, young adults, and adults with stories about the history of the Church. We also provide a wide selection of books on the doctrine of the Church. May God's Name be glorified and the readers edified by the reading of our books."/>
         </Helmet>
         <div className="row align-items-center about-us-heading">
            <div className="about-us-shadow">
               <h1>About Us</h1>
            </div>
         </div>


         <div className="row justify-content-center about-us-content p-1 p-md-3 p-lg-5">
            
            <div className="col-12 col-lg-8 p-3">
               <h2>About Inheritance Publications</h2>
               <div className="about-us-text">
                  <p>Inheritance Publications is a small company which was established to provide Biblical Reformed literature.</p>
                  <p>We want to maintain the antithesis between right and wrong, between true and false christianity.</p>
                  <p>It is also our desire to give God the honour and glory due to His Name because of His covenant faithfulness.</p>
                  <p>Remembering the great deeds of God in the history of His Church will always cause God's children to stand in awe of His Majesty.</p>
                  <p>It is our aim to reach children, young adults, and adults with stories about the history of the Church.</p>
                  <p>We also provide a wide selection of books on the doctrine of the Church. May God's Name be glorified and the readers edified by the reading of our books.</p>
                  <p>We serve all customers: retail stores at regular discounts, and private customers (mail order) at regular prices.</p>
               </div>
               <div className="d-flex justify-content-center align-items-center p-3">
                  <img src={protestantism} alt="History of Protestantism Vol.3" />
                  <div className="p-4"></div>
                  <img src={cdSet} alt="CD set" />
               </div>
            </div>
            
         </div>

         <div className="row justify-content-center about-us-content p-1 p-md-3 p-lg-5">
                        
            <div className="col-12 col-lg-8 p-4 aaaa">

               <h2>About Church Music & Records</h2>
               <div className="about-us-text">
                  <p>Church Music & Records is a small company specialized in Choral and Organ Recordings and Sheet Music on Psalms and Hymns for Choir and Organ.</p>
                  <p>In July 1978 the first LP records were sold by Roelof A. Janssen in the Netherlands.</p>
                  <p>In 1980 Roelof emigrated to Canada and soon started importing records, cassettes, and sheet music into Canada and the U.S.A.</p>
                  <p>In 1983 he also began to sell books and in 1997 he started publishing old English books and new translations from the Dutch under Inheritance Publications.</p>
                  <p>We serve all customers: retail stores at regular discounts, and private customers (mail order) at regular prices.</p>
               </div>
               <div className="d-flex p-3 justify-content-center">
                  <div>
                     <img src={genevan} alt="Genevan Psalms in Harmony" />
                  </div>
                  <div className="p-4"></div>
                  <div>
                     <img src={cdSing} alt="CD - Sing to the Lord" />
                  </div>
               </div>
            </div>
         </div>
      </main>
   )
}

export default AboutUs;